import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FlightBookedForForm.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import NumberInput from '../../../../../../moreCore/UI/NumberInput/NumberInput';
import DateTimeInput from '../../../../../../moreCore/UI/DateTimeInput/DateTimeInput';
import HintBox from '../../../../../../moreCore/UI/HintBox/HintBox';
import Edit from '../../../../../../moreCore/UI/Edit/Edit';
import "../../../../../../moreCore/UI/Edit/Edit";
import { BookedForLoadData } from "../../../TravelBookingListTypes";

class FlightBookedForForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private dateForerunInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    private dateStartInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    private durationInput: MdsLax<InstanceType<typeof NumberInput>>;
    private dateEndInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    private locationStartInput: MdsLax<InstanceType<typeof HintBox>>;
    private locationEndInput: MdsLax<InstanceType<typeof HintBox>>;
    private transportationCodeInput: MdsLax<InstanceType<typeof Edit>>;


    getData() {

    }

    setData(data: BookedForLoadData) {
        console.log(data);

        this.dateForerunInput.setValue(data.ref_vt_travel.date_forerun, true);
        this.dateStartInput.setValue(data.ref_vt_travel.date_start, true);
        this.durationInput.setValue(data.ref_vt_travel.duration, true);
        this.dateEndInput.setValue(data.ref_vt_travel.date_end, true);
        this.locationStartInput.setValue(data.ref_vt_travel.ref_location_start, true);
        this.locationEndInput.setValue(data.ref_vt_travel.ref_location_end, true);
        this.transportationCodeInput.setValue(data.ref_vt_travel.transportation_code, true);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.disableNode(this.transportationCodeInput);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FlightBookedForForm);